import React, { useCallback, useContext, useEffect, useState } from "react";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { StateContext as HomeStateContext } from "bodycodi/cmap/app/components/cmap2010/home";
import ChooseScheduleType from "./chooseScheduleType";
import AddScheduleStep from "./addScheduleStep";
import ChooseDate from "./chooseDateCalendar";
import ChooseMemberPass from "./choosememberPass/chooseMemberPass";
import ChooseMember from "./choosemember/chooseMemberPass";
import ChooseAppointmentTime from "./chooseAppointmentTime";
import ConditionAppointMentConfirm from "./conditionConfirmAppointment";
import ChooseTimePicker from "./chooseTimePicker";
import ConditionCsConfirm from "./conditionConfirmCs";
import ConditionOtConfirm from "./conditionConfirmOt";
import ConditionEtConfirm from "./conditionConfirmEt";

const AddSchedule = () => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { state: homeStateContext } = useContext(HomeStateContext);
  const { addScheduleStep: step } = state;
  const [scheduleType, setSchduleType] = useState("");
  const [time, setTime] = useState({});
  const [center, setCenter] = useState({});
  const [pass, setPass] = useState({});
  const [openConfirm, setOpenConfirm] = useState(false);
  const [chooseDate, setChooseDate] = useState({});
  const [member, setMember] = useState<{ seqMember: number }>({ seqMember: 0 });
  const [startTime, setStartTime] = useState({});
  const [endTime, setEndTime] = useState({});
  const [scheduleTitle, setScheduleTitle] = useState("");
  const [csDecs, setCsDecs] = useState("");
  const [holidayList, setHolidayList] = useState([]);
  const [isAvailableTime, setIsAvailableTime] = useState<boolean>(true);

  const handleReset = () => {
    setSchduleType("");
    setTime({});
    setPass({});
    setChooseDate({});
    setMember({ seqMember: 0 });
    setScheduleTitle("");
    setCsDecs("");
    setEndTime({});
    setStartTime({});
    setStep(1);
  };

  useEffect(() => {
    if (state.addScheduleMember === 0) {
      return;
    }
    setSchduleType(state.addScheduleType);
    setMember(state.addScheduleSeqMember);
    setPass(state.addSchedulePass);
    setCenter(state.addScheduleCenter);
    setChooseDateCalendarPop(true);
    setStep(3);
  }, [state.addScheduleMember]);

  useEffect(() => {
    setCenter({ ...homeStateContext.mySchedule });
  }, [homeStateContext.mySchedule]);

  // 1단계
  useEffect(() => {
    if (step === 5 || (step === 4 && scheduleType === "ET")) return;
    if (!state.chooseMemberPassPop && scheduleType === "APPOINTMENT" && !state.fromMngt) {
      handleReset();
      return;
    }
    if (!state.chooseMemberPop && scheduleType === "OT") {
      handleReset();
      return;
    }
    if (!state.chooseMemberPop && scheduleType === "CS") {
      handleReset();
      return;
    }
    if (!state.chooseDatePop && scheduleType === "ET") {
      handleReset();
      return;
    }
  }, [state.chooseMemberPassPop, state.chooseMemberPop, state.chooseDatePop]);

  // 2단계
  useEffect(() => {
    if (step === 5 || (step === 4 && scheduleType === "ET")) return;
    if (!state.chooseDatePop && scheduleType === "APPOINTMENT") {
      if (state.fromMngt) {
        setFromMngt();
        handleReset();
        return;
      }
      setChooseDate({});
      setStep(2);
      return;
    }
    if (!state.chooseDatePop && scheduleType === "OT") {
      setChooseDate({});
      setStep(2);
      return;
    }
    if (!state.chooseDatePop && scheduleType === "CS") {
      setChooseDate({});
      setStep(2);
      return;
    }
    if (!state.chooseTimePickerPop && scheduleType === "ET") {
      setTime({});
      setStartTime({});
      setEndTime({});
      setStep(2);
      return;
    }
  }, [state.chooseDatePop, state.chooseTimePickerPop]);

  // 3단계
  useEffect(() => {
    if (step === 5 || (step === 4 && scheduleType === "ET")) return;
    if (!state.chooseAppointmentTimePop && scheduleType === "APPOINTMENT") {
      setTime({});
      setStartTime({});
      setEndTime({});
      setStep(3);
      return;
    }
    if (!state.chooseTimePickerPop && scheduleType === "OT") {
      setTime({});
      setStartTime({});
      setEndTime({});
      setStep(3);
      return;
    }
    if (!state.chooseTimePickerPop && scheduleType === "CS") {
      setTime({});
      setStartTime({});
      setEndTime({});
      setStep(3);
      return;
    }
  }, [state.chooseAppointmentTimePop, state.chooseTimePickerPop]);

  // 개인레슨 확인
  useEffect(() => {
    if (!state.cofirmConditionApoointment) {
      if (state.fromMngt) {
        setFromMngt();
      }
      handleReset();
      return;
    }
  }, [state.cofirmConditionApoointment]);

  useEffect(() => {
    if (!state.cofirmConditionOt) {
      handleReset();
      return;
    }
  }, [state.cofirmConditionOt]);

  useEffect(() => {
    if (!state.cofirmConditionCs) {
      handleReset();
      return;
    }
  }, [state.cofirmConditionCs]);

  useEffect(() => {
    if (!state.cofirmConditionEt) {
      handleReset();
      return;
    }
  }, [state.cofirmConditionEt]);

  const setStep = useCallback((i: number) => {
    dispatch({ type: "UPDATE", data: { addScheduleStep: i } });
  }, []);

  const setChooseServiceTypePop = useCallback((open: boolean) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHOOSE_SCHEDULE_TYPE",
      open: { chooseServiceTypePop: open },
    });
  }, []);

  const setChooseDateCalendarPop = useCallback((open: boolean) => {
    dispatch({ type: "POP_UP_OPEN", id: "CHOOSE_DATE_POP", open: { chooseDatePop: open } });
  }, []);

  const setChooseMemberPassPop = useCallback((open: boolean) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHOOSE_MEMBER_PASS_POP",
      open: { chooseMemberPassPop: open },
    });
  }, []);

  const setChooseMemberPop = useCallback((open: boolean) => {
    dispatch({ type: "POP_UP_OPEN", id: "CHOOSE_MEMBER_POP", open: { chooseMemberPop: open } });
  }, []);

  const setChooseAppointMentTimePop = useCallback((open: boolean) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHOOSE_APPOINTMENT_TIME_POP",
      open: { chooseAppointmentTimePop: open },
    });
  }, []);

  const setConditionConfirmAppointment = useCallback((open: boolean) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CONFIRM_CONDITION_APPOINTMENT",
      open: { cofirmConditionApoointment: open },
    });
  }, []);

  const setConditionConfirmCs = useCallback((open: boolean) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CONFIRM_CONDITION_CS",
      open: { cofirmConditionCs: open },
    });
  }, []);

  const setConditionConfirmOt = useCallback((open: boolean) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CONFIRM_CONDITION_OT",
      open: { cofirmConditionOt: open },
    });
  }, []);

  const setConditionConfirmEt = useCallback((open: boolean) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CONFIRM_CONDITION_ET",
      open: { cofirmConditionEt: open },
    });
  }, []);

  const setChooseTimePop = useCallback((open: boolean) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHOOSE_TIME_PICKER_POP",
      open: { chooseTimePickerPop: open },
    });
  }, []);

  const setFromMngt = useCallback(() => {
    dispatch({ type: "UPDATE", data: { fromMngt: false } });
  }, []);

  const clickNextStep = useCallback(() => {
    if (step === 2) {
      if (scheduleType === "APPOINTMENT") {
        setChooseDateCalendarPop(true);
      } else if (scheduleType === "OT") {
        setChooseDateCalendarPop(true);
      } else if (scheduleType === "CS") {
        setChooseDateCalendarPop(true);
      } else if (scheduleType === "ET") {
        setChooseTimePop(true);
      }
      setStep(3);
    } else if (step === 3) {
      if (scheduleType === "APPOINTMENT") {
        setChooseAppointMentTimePop(true);
      } else if (scheduleType === "OT") {
        setChooseTimePop(true);
      } else if (scheduleType === "CS") {
        setChooseTimePop(true);
      } else if (scheduleType === "ET") {
        setChooseServiceTypePop(false);
        setChooseDateCalendarPop(false);
        setChooseTimePop(false);
        setConditionConfirmEt(true);
      }
      setStep(4);
    } else if (step === 4) {
      if (scheduleType === "APPOINTMENT") {
        if (!state.fromMngt) {
          setChooseServiceTypePop(false);
          setChooseMemberPassPop(false);
          setChooseDateCalendarPop(false);
          setChooseAppointMentTimePop(false);
        } else {
          setChooseDateCalendarPop(false);
          setChooseAppointMentTimePop(false);
        }
        setConditionConfirmAppointment(true);
      } else if (scheduleType === "OT") {
        setChooseServiceTypePop(false);
        setChooseMemberPop(false);
        setChooseDateCalendarPop(false);
        setChooseTimePop(false);
        setConditionConfirmOt(true);
      } else if (scheduleType === "CS") {
        setChooseServiceTypePop(false);
        setChooseMemberPop(false);
        setChooseDateCalendarPop(false);
        setChooseTimePop(false);
        setConditionConfirmCs(true);
      }
      setStep(5);
    }
  }, [step, scheduleType]);

  const clickPrevStep = useCallback(() => {
    if (step === 2) {
      if (scheduleType === "APPOINTMENT") {
        setChooseMemberPassPop(false);
      } else if (scheduleType === "OT") {
        setChooseMemberPop(false);
      } else if (scheduleType === "CS") {
        setChooseMemberPop(false);
      } else if (scheduleType === "ET") {
        setChooseDateCalendarPop(false);
      }
    } else if (step === 3) {
      if (scheduleType === "APPOINTMENT") {
        setChooseDateCalendarPop(false);
      } else if (scheduleType === "OT") {
        setChooseDateCalendarPop(false);
      } else if (scheduleType === "CS") {
        setChooseDateCalendarPop(false);
      } else if (scheduleType === "ET") {
        setChooseTimePop(false);
      }
    } else if (step === 4) {
      if (scheduleType === "APPOINTMENT") {
        setChooseAppointMentTimePop(false);
      } else if (scheduleType === "OT") {
        setChooseTimePop(false);
      } else if (scheduleType === "CS") {
        setChooseTimePop(false);
      }
    }
  }, [step, scheduleType]);

  return (
    <>
      {step !== 0 && (
        <>
          <ChooseScheduleType setSchduleType={setSchduleType} setStep={setStep} />
          <ChooseAppointmentTime
            fromMngt={state.fromMngt}
            pass={pass}
            chooseDate={chooseDate}
            setTime={setTime}
            setStep={setStep}
          >
            <AddScheduleStep
              open={openConfirm}
              setOpen={setOpenConfirm}
              center={center}
              step={step}
              setStep={setStep}
              scheduleType={scheduleType}
              clickNextStep={clickNextStep}
              clickPrevStep={clickPrevStep}
              pass={pass}
              chooseDate={chooseDate}
              time={time}
              member={member}
              startTime={startTime}
              endTime={endTime}
              scheduleTitle={scheduleTitle}
              holidayList={holidayList}
            />
          </ChooseAppointmentTime>
          {/* 날짜 선택 */}
          <ChooseDate
            fromMngt={state.fromMngt}
            scheduleType={scheduleType}
            pass={pass}
            setStep={setStep}
            setChooseDate={setChooseDate}
            setHolidayList={setHolidayList}
          >
            <AddScheduleStep
              open={openConfirm}
              setOpen={setOpenConfirm}
              center={center}
              step={step}
              setStep={setStep}
              scheduleType={scheduleType}
              clickNextStep={clickNextStep}
              clickPrevStep={clickPrevStep}
              pass={pass}
              chooseDate={chooseDate}
              time={time}
              member={member}
              startTime={startTime}
              endTime={endTime}
              scheduleTitle={scheduleTitle}
              holidayList={holidayList}
            />
          </ChooseDate>
          <ChooseMemberPass setPass={setPass} setMember={setMember} setStep={setStep}>
            <AddScheduleStep
              open={openConfirm}
              setOpen={setOpenConfirm}
              center={center}
              step={step}
              setStep={setStep}
              scheduleType={scheduleType}
              clickNextStep={clickNextStep}
              clickPrevStep={clickPrevStep}
              pass={pass}
              chooseDate={chooseDate}
              time={time}
              member={member}
              startTime={startTime}
              endTime={endTime}
              scheduleTitle={scheduleTitle}
              holidayList={holidayList}
            />
          </ChooseMemberPass>
          <ChooseMember
            scheduleType={scheduleType}
            member={member}
            setMember={setMember}
            setStep={setStep}
          >
            <AddScheduleStep
              open={openConfirm}
              setOpen={setOpenConfirm}
              center={center}
              step={step}
              setStep={setStep}
              scheduleType={scheduleType}
              clickNextStep={clickNextStep}
              clickPrevStep={clickPrevStep}
              pass={pass}
              chooseDate={chooseDate}
              time={time}
              member={member}
              startTime={startTime}
              endTime={endTime}
              scheduleTitle={scheduleTitle}
              holidayList={holidayList}
            />
          </ChooseMember>

          {/* 시간 선택 */}
          <ChooseTimePicker
            setEndTime={setEndTime}
            setStartTime={setStartTime}
            setScheduleTitle={setScheduleTitle}
            setCsDecs={setCsDecs}
            scheduleType={scheduleType}
            step={step}
            chooseDate={chooseDate}
            startTime={startTime}
            endTime={endTime}
            scheduleTitle={scheduleTitle}
            csDecs={csDecs}
            isAvailableTime={isAvailableTime}
            setIsAvailableTime={setIsAvailableTime}
            seqMember={member?.seqMember}
          >
            <AddScheduleStep
              open={openConfirm}
              setOpen={setOpenConfirm}
              center={center}
              step={step}
              setStep={setStep}
              scheduleType={scheduleType}
              clickNextStep={clickNextStep}
              clickPrevStep={clickPrevStep}
              pass={pass}
              chooseDate={chooseDate}
              time={time}
              member={member}
              startTime={startTime}
              endTime={endTime}
              scheduleTitle={scheduleTitle}
              holidayList={holidayList}
              isAvailableTime={isAvailableTime}
            />
          </ChooseTimePicker>
          <ConditionAppointMentConfirm
            time={time}
            chooseDate={chooseDate}
            pass={pass}
            member={member}
            handleReset={handleReset}
          />
          <ConditionCsConfirm
            time={time}
            scheduleType={scheduleType}
            handleReset={handleReset}
            chooseDate={chooseDate}
            scheduleTitle={scheduleTitle}
            csDecs={csDecs}
            center={center}
            member={member}
            startTime={startTime}
            endTime={endTime}
          />
          <ConditionOtConfirm
            time={time}
            scheduleType={scheduleType}
            handleReset={handleReset}
            chooseDate={chooseDate}
            scheduleTitle={scheduleTitle}
            csDecs={csDecs}
            center={center}
            member={member}
            startTime={startTime}
            endTime={endTime}
          />
          <ConditionEtConfirm
            time={time}
            scheduleType={scheduleType}
            handleReset={handleReset}
            chooseDate={chooseDate}
            scheduleTitle={scheduleTitle}
            csDecs={csDecs}
            center={center}
            startTime={startTime}
            endTime={endTime}
          />
        </>
      )}
    </>
  );
};

export default AddSchedule;
